import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  checkExtFolders,
  checkExtRelatedListSettings,
  checkZohoAuth,
  getZohoAuthUrl,
  getZUID,
  revokeZoho,
  setUpOrgVariable,
  verifyZohoAuthAndCreateRelatedListWidget,
} from "../../Components/API/ZohoAPICalling";
import {
  authCheckDuration,
  getOpenSnakErrorData,
  getOpenSnakSuccessData,
  maxAuthCheck,
  snackDetails,
} from "../../config/otherConstant";
import { ZUID_API_NAME } from "../../config/serviceConstant";
import RevokeDialog from "./RevokeDialog";

const ZOHO = window?.ZOHO;
let checkAuthCount;

function ZohoAuthentication({
  apiKey,
  orgId,
  dataCenterUrl,
  dataCenter,
  zApiKey,
  zuid,
  setZuid,
  zohoAuth,
  connName,
  setZohoAuth,
  currentUser,
  defaultAuthenticator,
  authenticatedUserMap,
  setAuthenticatedUserMap,
  setSnack,
}) {
  const [authLoading, setAuthLoading] = useState(true);
  const [revokeLoading, setRevokeLoading] = useState(false);

  const zohoHeaders = {
    orgid: orgId,
    connname: connName,
    apikey: apiKey,
    datacenterurl: dataCenterUrl,
    dataCenter: dataCenter,
    zapikey: zApiKey,
  };

  const handleAuthenticate = async () => {
    setAuthLoading(true);
    const zohoAuthUrl = await getZohoAuthUrl(zohoHeaders);
    if (!zohoAuthUrl) {
      // Set snak error
      setAuthLoading((prev) => false);
      setSnack(getOpenSnakErrorData());
      return "Error";
    }

    checkAuthCount = 1;
    const myAuthCheckInterval = setInterval(async () => {
      const zohoStatus = await checkZohoAuth(zohoHeaders);
      const authCheckStatus = await handleAuthCheck();
      const { isAuthenticated, isRelatedListCreated } = authCheckStatus;

      if (isAuthenticated) {
        const workdriveZuid = await getZUID(zohoHeaders);
        const zuid = workdriveZuid?.data?.data;
        let user_map = {};
        user_map[defaultAuthenticator] = {
          email: defaultAuthenticator,
          role: "admin",
          platform: "zoho",
        };
        setAuthenticatedUserMap((prev) => user_map);
        await setUpOrgVariable(ZOHO, ZUID_API_NAME, zuid);
        await checkExtFolders(zuid, zohoHeaders);
        await checkExtRelatedListSettings(zohoHeaders);
        setSnack(getOpenSnakSuccessData());
        setZohoAuth((prev) => true);
        setAuthLoading((prev) => false);
        clearInterval(myAuthCheckInterval);
      }

      if (checkAuthCount++ > maxAuthCheck) {
        setSnack(
          getOpenSnakErrorData(
            "Error!!! Please authenticate and refresh the page.",
            10 * 1000
          )
        );
        setAuthLoading((prev) => false);
        clearInterval(myAuthCheckInterval);
      }
    }, authCheckDuration);

    const newwindow = window.open(
      zohoAuthUrl,
      "windowName",
      "height=640,width=1024"
    );

    if (window.focus) {
      newwindow.focus();
    }
  };

  const handleAuthCheck = async () => {
    try {
      const zohoAuthResp = await verifyZohoAuthAndCreateRelatedListWidget(
        zohoHeaders
      );
      return zohoAuthResp;
    } catch (error) {
      return false;
    }
  };

  const handleRevoke = async () => {
    setRevokeLoading((prev) => true);
    const revokeResp = await revokeZoho(zohoHeaders);
    const authCheckStatus = await checkZohoAuth(zohoHeaders);
    setZohoAuth((prev) => authCheckStatus);

    delete authenticatedUserMap[defaultAuthenticator];
    setAuthenticatedUserMap((prev) => authenticatedUserMap);
    setSnack(getOpenSnakSuccessData());
    setRevokeLoading((prev) => false);
  };

  const checkAuth = async (cb) => {
    const zohoStatus = await checkZohoAuth(zohoHeaders);
    cb(zohoStatus);
  };

  useEffect(() => {
    if (orgId && apiKey && dataCenterUrl) {
      checkAuth((bool) => {
        setZohoAuth((prev) => bool);
        setAuthLoading((prev) => false);
      });
    }
  }, []);

  if (authLoading) {
    return (
      <Button disabled variant="outlined" size="small">
        Authenticating...
      </Button>
    );
  }

  if (revokeLoading) {
    return (
      <Button disabled variant="outlined" size="small">
        Revoking...
      </Button>
    );
  }

  if (!zohoAuth) {
    return (
      <Button onClick={handleAuthenticate} variant="outlined" size="small">
        Authenticate Zoho
      </Button>
    );
  }

  if (zohoAuth) {
    return (
      // <Button onClick={handleRevoke} variant="outlined" size="small">
      //   Revoke Zoho
      // </Button>
      <>
        {Object.keys(authenticatedUserMap)?.length >= 2 ||
        (Object.keys(authenticatedUserMap)?.length == 1 &&
          Object.keys(authenticatedUserMap)?.[0] != defaultAuthenticator) || (currentUser?.email != defaultAuthenticator) ? (
          <Button disabled>Revoke</Button>
        ) : (
          <RevokeDialog
            service="zoho"
            handleRevokeService={handleRevoke}
            defaultAuthenticator={defaultAuthenticator}
          />
        )}
      </>
    );
  }

  return <></>;
}

export default ZohoAuthentication;
